import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class Slide {
    constructor() {
        this.init();
    }

    init() {
        this.modalSwiper();
    }

    modalSwiper() {
        [...document.querySelectorAll(".js-swiper")].forEach(($slide) => {
            const $slideitem = $slide.querySelector(
                ".bluraycd_detail_modal__slide"
            );
            const $slideitemnum = $slide.querySelectorAll(
                ".bluraycd_detail_modal__item"
            );
            const $pagination = $slide.querySelector(
                ".bluraycd_detail_modal-pagination"
            );
            const $navigationnext = $slide.querySelector(
                ".bluraycd_detail_modal-button-next"
            );
            const $navigationprev = $slide.querySelector(
                ".bluraycd_detail_modal-button-prev"
            );

            var loopval = "";

            if ($slideitemnum.length === 1) {
                loopval = false;
            } else {
                loopval = true;
            }

            const opts = {
                slidesPerView: "1",
                spaceBetween: 10,
                loop: loopval,
                pagination: {
                    el: $pagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: $navigationnext,
                    prevEl: $navigationprev,
                },
                observer: true,
                observeParents: true,
            };

            const swiper = new Swiper($slideitem, opts);
        });
    }
}
